<template>
  <div class="document-edit-name-dialog">
    <vs-prompt
      @accept="updatecurrentDocument"
      @cancel="cancel"
      @close="close"
      :color="AISEA_COLOR.BLUE"
      :active.sync="showDialog"
      :title="title"
      :accept-text="acceptText"
      :cancel-text="cancelText"
      :is-valid="validateForm"
    >
      <div>
        <span>名前</span>
        <vs-input
          v-model="newDocumentName"
          class="w-full"
          v-validate="'required|max:255'"
          :name="fieldName"
          @input="validateName"
          data-vv-as="名前"
        />
        <span class="text-danger text-sm" v-show="errors.any()">
          {{ errors.first(fieldName) }}
        </span>
        <br />
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import _ from "lodash";
import { createNamespacedHelpers } from "vuex";
import { ColorMixin, DocumentMixin } from "@/mixins";

const {
  mapActions: mapActionsOfenterpriseDocumentManager,
} = createNamespacedHelpers("enterpriseDocumentManager");

export default {
  components: {},
  mixins: [ColorMixin, DocumentMixin],
  data () {
    return {
      currentDocument: null,
      newDocumentName: "",
      error: { message: null },
      showDialog: false,
      title: "編集",
      acceptText: "変更",
      cancelText: "キャンセル",
      isValid: true,
      isFolder: false,
      fieldName: "edit-name"
    };
  },
  computed: {
    validateForm () {
      return (
        this.required() && !this.isSameName() && !this.errors.any()
      );
    }
  },
  methods: {
    ...mapActionsOfenterpriseDocumentManager(["renameFolder", "renameFile", "documentExists"]),

    show (currentDocument, isFolder) {
      this.currentDocument = _.cloneDeep(currentDocument);
      this.newDocumentName = currentDocument.name
      this.showDialog = true;
      this.isFolder = isFolder;
    },

    required () {
      return this.newDocumentName !== null && this.newDocumentName.length !== 0
    },

    async validateName () {

      if(this.newDocumentName === this.currentDocument.name) {
        this.$validator.errors.remove(this.fieldName);
        return;
      }

      if(this.newDocumentName.length === 0) {
        this.$validator.errors.remove(this.fieldName);
        return;
      }

      this._validateName(this)
    },

    _validateName:  _.debounce(async (self) => {
      const payload = {
        name: self.newDocumentName,
        field: self.fieldName,
      }
      
      self.isFolder ?
        await self.validateExistsFolderName(payload) :
        await self.validateExistsFileName(payload) 
      self.validateSlash(payload)
    }, 100),

    isSameName () {
      return this.newDocumentName === this.currentDocument.name
    },
    
    async updatecurrentDocument () {
      try {
        this.$vs.loading();

        const param = {
          sourcePath: this.currentDocument.path,
          destName: this.newDocumentName
        }

        if (this.isFolder) {
          await this.renameFolder(param)
        } else {
          await this.renameFile(param)
        }
        this.$vs.loading.close();
        this.$vs.notify({
          title:
            "名前を変更しました",
          color: "success",
          iconPack: "feather",
          icon: "icon-check"
        });
        this.$emit("onUpdate");
        this.close();
      } catch (error) {
        console.error(error);
        this.$vs.notify({
          title: `名前の変更に失敗しました`,
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square"
        });
      }
      this.$vs.loading.close();
    },

    close () {
      this.cleanUp();
    },

    cancel () {
      this.cleanUp();
    },

    cleanUp () {
      this.showDialog = false;
      this.$validator.errors.remove(this.fieldName)
    }
  }
};
</script>

<style lang="scss"></style>
